/* global cookieUtils  */
import React, { useEffect, useContext, useState, createRef } from 'react';
import classNames from 'classnames';
import { bool, func, string } from 'prop-types';
import { useTheme } from '@thd-olt-component-react/theme-provider';
// import { useProduct, useMylist } from '@thd-nucleus/data-sources';
import { getDomPath, ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
import { useProductDeprecated, useMylistDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import './favorite.style.scss';
import { dataModel } from './dataModel';

let customerInfoCache;

const Favorite = (props) => {
  const {
    className,
    collectionId,
    collectionImage,
    showHoverInfo,
    iconClass,
    itemId,
    label,
    pageType,
    showCircle,
    showCount,
    small,
    storeId: propStoreId,
    vertical
  } = props;

  const { channel } = useContext(ExperienceContext);
  const defaultStoreId = useStoreId();
  const storeId = propStoreId || defaultStoreId;
  const theme = useTheme(Favorite, props);
  const { showPlusSign } = theme.props;
  const favoritesRef = createRef();
  let favoriteCount;
  let isFavorite = false;

  let iconClassList = classNames(
    iconClass,
    'Favorite-icon',
    {
      'Favorite-icon--selected': isFavorite && !showPlusSign,
      'Favorite-icon--plus--selected': isFavorite && showPlusSign,
      'Favorite-icon--display': !label,
      'Favorite-icon--plus': showPlusSign
    }
  );
  const [iconClasses, setIconClasses] = useState(iconClassList);
  const [disableTooltip, setDisableTooltip] = useState(false);
  const [customerInfo, setCustomerInfo] = useState({});
  const { customerAccountID, userId, customerType } = customerInfo;

  useEffect(() => {
    async function getAGUI() {
      const agui = await Favorite.getAccountGlobalUI();
      Favorite.accountglobaluilist = agui;
      if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
        LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('save-to-favorites.ready');
      }
    }
    getAGUI();

    // THDCustomer getters parse all the cookies in the document, causing a
    // significant performance hit for doing this on every render of Favorite.
    // This caches the data we need from it to fix performance.
    // @TODO: Put the below information into the customer-information hook
    // currently work-in-progress from B2B team.
    customerInfoCache = customerInfoCache || {
      customerAccountID: window.THDCustomer?.default?.svocID,
      userId: window.THDCustomer?.default?.userID,
      customerType: window.THDCustomer?.default?.customerType || 'B2C'
    };

    setCustomerInfo(customerInfoCache);
  }, []);

  const {
    data: myListData,
    loading: myListLoading,
    error: myListError
  } = useMylistDeprecated({
    customerAccountID,
    userId,
    customerType,
    skip: (!customerAccountID || !userId)
  });

  if (typeof window !== 'undefined' && window.THDCustomer) {
    if (myListData && !myListError) {
      const { listDetails } = myListData?.listDetails?.listResponse || [];
      (listDetails || []).forEach((list) => {
        const { items } = list;
        (items || []).forEach((item) => {
          if (item.itemId === itemId) {
            isFavorite = true;
          }
        });
      });
    }
  }

  const productDomains = ['media', 'pricing'];
  if (showCount) {
    productDomains.push('favoriteDetail');
  }

  const { data, loading, error } = useProductDeprecated({
    itemId,
    storeId,
    domains: productDomains,
    ssr: false
  });

  if (loading || (error && !data)) {
    return null;
  }

  if (showCount) {
    favoriteCount = data?.product?.favoriteDetail?.count;
  }

  const { image } = data?.product?.media || {};
  const imageUrl = image?.url.replace('<SIZE>', '400') || collectionImage;
  const itemPrice = data?.product?.pricing?.value;

  const saveToList = (event) => {
    const {
      onClick,
      onFavoriteChange,
    } = props;

    const path = getDomPath(favoritesRef);
    let analyticsSource = '';
    if (pageType === 'browse') {
      analyticsSource = 'plp';
    } else if (pageType === 'search') {
      analyticsSource = 'search results';
    } else if (path.indexOf('ProductPage[0]') > -1) {
      analyticsSource = 'pip';
    } else if (path.indexOf('PepPage[0]') > -1) {
      analyticsSource = 'pep';
    }

    const isMobileChannel = channel === 'mobile';
    const config = {
      source: analyticsSource,
      isMobileChannel,
      $trigger: event.currentTarget,
      item: {
        itemId: itemId || collectionId,
        type: collectionId ? 'collection' : 'item',
        quantity: 1,
        imageURL: imageUrl,
        price: itemPrice
      }
    };

    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.on('ITEM_ADDED_TO_LIST', (payload) => {
        const { output = {} } = payload;
        const { item = {} } = output;
        if (item.itemId === itemId) {
          isFavorite = true;
          iconClassList = classNames(
            iconClass,
            'Favorite-icon',
            {
              'Favorite-icon--selected': isFavorite && !showPlusSign,
              'Favorite-icon--plus--selected': isFavorite && showPlusSign,
              'Favorite-icon--display': !label,
              'Favorite-icon--plus': showPlusSign
            }
          );
          setIconClasses(iconClassList);
          if (onFavoriteChange) {
            onFavoriteChange(parseInt(item.itemId, 0));
          }
        }
        window.LIFE_CYCLE_EVENT_BUS.off('ITEM_ADDED_TO_LIST');
      });
    }
    if (Favorite.accountglobaluilist && Favorite.accountglobaluilist.myList) {
      Favorite.accountglobaluilist.myList.saveToList(config);
    }
    if (onClick) {
      onClick(event, { ...props });
    }
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('save-to-favorites.click', { ...props });
    }
  };

  let favoriteCountRoundOff = favoriteCount;
  const maxFavoriteCount = 9999;
  if (favoriteCount && favoriteCount > maxFavoriteCount) {
    favoriteCountRoundOff = `${(favoriteCount / 1000).toFixed(1)}k`;
  }
  const circleClasses = classNames('Favorite-wrapper-icon', {
    'Favorite-wrapper--circle': showCircle,
    'Favorite-wrapper--circle-count': favoriteCount > 0
  });

  const buttonClasses = classNames(
    className,
    'Favorite-wrapper',
    {
      'Favorite-wrapper__label--horizontal': label && !vertical,
      'Favorite-icon__label--vertical': label && vertical,
      'Favorite-wrapper--plus': showPlusSign,
      'Favorite-wrapper--small': small
    }
  );

  let tooltipInfo = 'Add to favorites';
  if (customerAccountID) {
    tooltipInfo += ' or a new list';
  }
  const FavoriteButton = React.forwardRef((favProps, ref) => {
    return (
      <div ref={ref}>
        <Tooltip
          interactive
          closeButton
          content="Clicked content Clicked content Clicked content Clicked content"
          placement="bottom"
          visible={disableTooltip}
        >
          <button
            type="button"
            className={buttonClasses}
            onClick={() => setDisableTooltip(!disableTooltip)}
            onClose={() => setDisableTooltip(false)}
            ref={favoritesRef}
          >
            <span className={circleClasses}>
              <span className={iconClasses} />
              {favoriteCount > 0 && (<span className="Favorite-wrapper--count">{favoriteCountRoundOff}</span>)}
            </span>
            {label && (<span className="Favorite-wrapper__label">{label}</span>)}
          </button>
        </Tooltip>
      </div>
    );
  });

  return (
    <>
      {(itemId || collectionId) && (showHoverInfo ? (
        <Tooltip
          interactive
          content={tooltipInfo}
          placement="bottom"
          maxWidth={125}
          disableTooltip={disableTooltip}
        >
          <FavoriteButton />
        </Tooltip>
      ) : (
        <button
          type="button"
          className={buttonClasses}
          onClick={saveToList}
          ref={favoritesRef}
        >
          <span className={circleClasses}>
            <span className={iconClasses} />
            {favoriteCount > 0 && (<span className="Favorite-wrapper--count">{favoriteCountRoundOff}</span>)}
          </span>
          {label && (<span className="Favorite-wrapper__label">{label}</span>)}
        </button>
      ))}
    </>
  );
};

Favorite.getAccountGlobalUI = async () => {
  const { default: agui } = await import(/* webpackChunkName: "account-global-ui" */ 'account-global-ui');
  return agui;
};

Favorite.propTypes = {
  className: string,
  collectionId: string,
  collectionImage: string,
  showHoverInfo: bool,
  iconClass: string,
  itemId: string,
  label: string,
  onClick: func,
  onFavoriteChange: func,
  pageType: string,
  showCircle: bool,
  showCount: bool,
  small: bool,
  storeId: string,
  vertical: bool,
};

Favorite.defaultProps = {
  className: null,
  collectionId: null,
  collectionImage: null,
  showHoverInfo: false,
  iconClass: null,
  itemId: null,
  label: null,
  onClick: null,
  onFavoriteChange: null,
  pageType: null,
  showCircle: false,
  showCount: false,
  small: false,
  storeId: null,
  vertical: false,
};

Favorite.themeProps = {
  showPlusSign: bool
};

Favorite.defaultThemeProps = {
  showPlusSign: false
};

Favorite.displayName = 'Favorite';

Favorite.dataModel = dataModel;

export { Favorite };
